
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/custom",
      function () {
        return require("private-next-pages/apps/custom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/custom"])
      });
    }
  